import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../../utils/reactDomPatch';
import './HelpSupport.css';
import api from '../../api/axios';

const HelpSupport = () => {
  const [formData, setFormData] = useState({
    call: '',
    whatsapp: '',
    email: '',
    termsAndConditions: '',
    privacyPolicy: ''
  });
  const [savedEntry, setSavedEntry] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const quillModules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link']
      ]
    }
  };

 const fetchHelpSupport = async () => {
    try {
      const res = await api.get('/help-support')
      if (res.data?.data) {
        console.log(res.data,"red")
        setSavedEntry(res.data.data);
        setFormData({
          call: res.data.data.call || '',
          whatsapp: res.data.data.whatsapp || '',
          email: res.data.data.email || '',
          termsAndConditions: res.data.data.termsAndConditions || '',
          privacyPolicy: res.data.data.privacyPolicy || ''
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

   useEffect(() => {
    fetchHelpSupport()
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post('/admin/help-support', formData)
      setSavedEntry(res.data?.data);
      setShowEditModal(false);
      toast.success('Help & Support saved successfully!');
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }


  // const handleDelete = async () => {
  //   if (window.confirm('Are you sure you want to delete this information?')) {
  //     try {
  //       await api.delete('/admin/help-support')
  //       setSavedEntry(null);
  //       setFormData({
  //         call: '',
  //         whatsapp: '',
  //         email: '',
  //         termsAndConditions: '',
  //         privacyPolicy: ''
  //       });
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }
  // };

  const handleEdit = () => {
    if (savedEntry) {
      setFormData(savedEntry);
    }
    setShowEditModal(true);
  };

  const handleCancel = () => {
    setFormData({
      call: '',
      whatsapp: '',
      email: '',
      termsAndConditions: '',
      privacyPolicy: ''
    });
    setShowEditModal(false);
  };

  return (
    <div className="help-support-container">
      <div className="page-header">
        <h1>Help & Support</h1>
        <p>Manage contact information and support resources</p>
      </div>

      {savedEntry ? (
        <div className="saved-entry">
          <div className="entry-header">
            <h2>Help & Support Information</h2>
            <div className="entry-actions">
              {/* <span className="entry-date">Last updated: {savedEntry.updatedAt}</span> */}
              <div className="action-buttons">
                <button className="btn-edit" onClick={handleEdit}>
                  Edit
                </button>
                {/* <button className="btn-delete" onClick={handleDelete}>
                  Delete
                </button> */}
              </div>
            </div>
          </div>
          <div className="entry-content">
            <div className="entry-field">
              <strong>Call Number:</strong> {savedEntry.call || 'Not provided'}
            </div>
            <div className="entry-field">
              <strong>WhatsApp Number:</strong> {savedEntry.whatsapp || 'Not provided'}
            </div>
            <div className="entry-field">
              <strong>Email Address:</strong> {savedEntry.email || 'Not provided'}
            </div>
            <div className="entry-field">
              <strong>Terms & Conditions:</strong>
              <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: savedEntry.termsAndConditions || 'Not provided' }} />
            </div>
            <div className="entry-field">
              <strong>Privacy Policy:</strong>
              <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: savedEntry.privacyPolicy || 'Not provided' }} />
            </div>
          </div>
        </div>
      ) : (
        <div className="no-entry">
          <h2>No Help & Support Information</h2>
          <p>Click the button below to add help and support information.</p>
          <button className="btn-primary" onClick={() => setShowEditModal(true)}>
            Add Information
          </button>
        </div>
      )}

      {showEditModal && (
        <div className="modal-overlay" onClick={handleCancel}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{savedEntry ? 'Edit Help & Support' : 'Add Help & Support'}</h2>
              <button className="close-btn" onClick={handleCancel}>×</button>
            </div>
            
            <form id="help-support-form" onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="call">Call Number</label>
                  <input
                    type="tel"
                    id="call"
                    name="call"
                    value={formData.call}
                    onChange={handleInputChange}
                    placeholder="Enter contact number"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="whatsapp">WhatsApp Number</label>
                  <input
                    type="tel"
                    id="whatsapp"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleInputChange}
                    placeholder="Enter WhatsApp number"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter email address"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="termsAndConditions">Terms and Conditions</label>
                  <ReactQuill
                    theme="snow"
                    value={formData.termsAndConditions}
                    onChange={(value) => setFormData(prev => ({ ...prev, termsAndConditions: value }))}
                    modules={quillModules}
                    placeholder="Enter terms and conditions"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="privacyPolicy">Privacy Policy</label>
                  <ReactQuill
                    theme="snow"
                    value={formData.privacyPolicy}
                    onChange={(value) => setFormData(prev => ({ ...prev, privacyPolicy: value }))}
                    modules={quillModules}
                    placeholder="Enter privacy policy"
                  />
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn-cancel" onClick={handleCancel}>
                  Cancel
                </button>
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save Information'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
       <ToastContainer
              toastClassName="custom-toast"
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
    </div>
  );
};

export default HelpSupport;